export function setSendMessagesPayload(state, data) {
    state.sendMessagesPayload = data;
}

export function setTemplates(state, data) {
    state.templates = data;
}

export function setDefaultTemplate(state, item) {
    state.defaultTemplate = item;
}

export function setResponseApi(state, item) {
    state.responseApi = item;
}



// WEBPACK FOOTER //
// ./src/modules/whatsapp-api/mutations.js